import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class Role {
  /* 角色组列表 */
  static getRoleGroupList() {
    const url = `/oa/api/biz/role/list`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 新增角色组 */
  static postAddRoleGroup(data) {
    const url = `/oa/api/biz/role/add`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 修改角色组 */
  static postModRoleGroup(data) {
    const url = `/oa/api/biz/role/update`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 删除角色组 */
  static postDelRoleGroup(data) {
    const url = `/oa/api/biz/role/delete`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 新增角色权限 */
  static postSaveMenuAuth(data) {
    const url = `/oa/api/biz/role/authority/add`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 角色权限列表 */
  static getRoleAuth(options) {
    let url = `/oa/api/biz/role/authority/list?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Role